// Helpers
import { to } from '../../../lib/helpers';

// Requests
import { userGetUserSecurityQuestionsRequest } from '../../../backend/userRequests';

// Consts
export const USER_GET_USER_SECURITY_QUESTIONS_SUCCESS_RECEIVED =
  '[USER] Get User Security Questions Success';

export const getUserSecurityQuestions = () => async dispatch => {
  const [{ response, body }] = await to(
    dispatch(userGetUserSecurityQuestionsRequest())
  );

  if (!body) return false;
  if (response.status !== 200) return Promise.reject({ response, body });

  dispatch({
    type: USER_GET_USER_SECURITY_QUESTIONS_SUCCESS_RECEIVED,
    payload: body.data,
  });

  return Promise.resolve({ response, body });
};
